import { render, staticRenderFns } from "./FarmBarnsView.vue?vue&type=template&id=6081db52&"
import script from "./FarmBarnsView.vue?vue&type=script&lang=ts&"
export * from "./FarmBarnsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports